import { useEffect } from 'react'
import { useTrackMutation } from '@mote/api'
import { TRACK_EVENT_NAMES } from '../../constants'

/**
 * @typedef {'myAnalytics' | 'myLoops' | 'home' | 'profile' | 'users' | 'notifications' | 'analytics' | 'referral'} AccountPageEventName
 */

/**
 * @param {AccountPageEventName} event
 * @returns {void}
 */
export const useAccountPageTrack = event => {
  const { mutate: track } = useTrackMutation()

  useEffect(() => {
    track({
      variables: {
        event: TRACK_EVENT_NAMES.site.account[event]
      }
    })
  }, [])
}
